import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-ink pb-28 pt-14 md:pb-14">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 md:flex-row md:items-center">
      <Logo />
      <nav className="flex flex-wrap items-center gap-6">
        {[
          { id: "about", label: "Mentor" },
          { id: "weeks", label: "The 8 Weeks" },
          { id: "pricing", label: "Pricing" },
          { id: "apply", label: "Apply" },
        ].map((l) => (
          <button
            key={l.id}
            data-testid={`footer-link-${l.id}`}
            onClick={() => scrollToId(l.id)}
            className="text-[11px] uppercase tracking-[0.22em] text-white/45 transition-colors hover:text-bone"
          >
            {l.label}
          </button>
        ))}
        <a
          data-testid="footer-instagram-link"
          href="https://www.instagram.com/daguti_"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[11px] uppercase tracking-[0.22em] text-white/45 transition-colors hover:text-bone"
        >
          Instagram ↗
        </a>
      </nav>
    </div>
    <div className="mx-auto mt-10 flex max-w-7xl flex-col justify-between gap-3 border-t border-white/10 px-5 pt-6 text-xs text-white/35 sm:px-8 md:flex-row">
      <p>© 2026 The Embodied Creator. All rights reserved.</p>
      <p className="font-serif italic">No hype. No guarantees. Just the work.</p>
    </div>
  </footer>
);

export default Footer;
